import React from 'react'
import { SectionCard } from '@enamelai/design-system'

type ReportSectionCardProps = React.PropsWithChildren<{
  className?: string
}>

/** Canonical report surface while retaining report-specific layout hooks. */
function ReportSectionCard({
  children,
  className,
}: ReportSectionCardProps): React.ReactElement {
  return (
    <SectionCard className={className} radius="md">
      {children}
    </SectionCard>
  )
}

export default ReportSectionCard
